import { render, staticRenderFns } from "./StarRatingField.vue?vue&type=template&id=28626078&scoped=true&"
import script from "./StarRatingField.vue?vue&type=script&lang=js&"
export * from "./StarRatingField.vue?vue&type=script&lang=js&"
import style0 from "./StarRatingField.vue?vue&type=style&index=0&id=28626078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28626078",
  null
  
)

export default component.exports